var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0,
    width: 25,
    height: 13,
    rx: 6.5,
    fill: "#00537f"
  }))), /*#__PURE__*/React.createElement("g", {
    "aria-label": "S5",
    style: {
      transform: "translate(0.5px, 0)",
      fontWeight: "bold",
      fontSize: 10,
      fontFamily: "HelveticaNeue-Bold, 'Helvetica Neue'",
      fill: "#fff"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 6.7149999,7.63 h 1.52 q 0,0.67 0.48,1.02 0.41,0.3 1.1,0.3 0.5400001,0 0.9000001,-0.17 0.49,-0.23 0.49,-0.72 0,-0.61 -1.1,-0.92 Q 8.2049999,6.6 8.0549999,6.52 q -1.1,-0.53 -1.1,-1.67 0,-1.03 0.85,-1.63 0.76,-0.53 1.82,-0.53 1.2300001,0 1.9900001,0.53 0.87,0.61 0.87,1.77 h -1.52 q -0.06,-1.08 -1.4100001,-1.08 -0.43,0 -0.73,0.18 -0.35,0.22 -0.35,0.63 0,0.39 0.39,0.57 0.3,0.14 1.7400001,0.51 0.84,0.21 1.25,0.48 0.87,0.56 0.87,1.6 0,1.02 -0.76,1.64 -0.8,0.65 -2.2100001,0.65 -1.29,0 -2.12,-0.61 -0.93,-0.69 -0.92,-1.93 z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 18.420933,3.0014594 h -3.823718 l -0.674774,3.7846008 h 1.251755 c 0.273821,-0.3813939 0.547642,-0.5476425 1.046388,-0.5476425 0.743229,0 1.183299,0.5672012 1.183299,1.2810923 0,0.6845531 -0.459629,1.3202096 -1.183299,1.3202096 -0.616098,0 -1.056168,-0.4107319 -1.124623,-1.0268297 h -1.388665 c 0.02934,1.4375615 1.212637,2.1710113 2.542626,2.1710113 1.369106,0.029338 2.542626,-1.0561677 2.542626,-2.4643912 0,-1.2810923 -0.762788,-2.3274806 -2.112336,-2.3274806 -0.547642,0 -0.958374,0.1466899 -1.339768,0.5280838 l -0.01956,-0.019559 0.273821,-1.5549136 h 2.826226 z",
    style: {
      fill: "#ffffff"
    },
    id: "path2853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS5);
export default __webpack_public_path__ + "static/media/s5.498938b1669cc8e51856992ae4b28384.svg";
export { ForwardRef as ReactComponent };